module.exports = __webpack_public_path__ + "img/cat_hr.74110920.png";